export class OrderInformation {
    specialInstructions: string | null;
    whosThisFor: string | null;
}
